import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { TranslatorContext } from '@jutro/locale';
import { useDependencies } from 'gw-portals-dependency-react';
import { useValidation } from 'gw-portals-validation-react';
import { ServiceManager } from '@jutro/services';
import AdditionalInsuredInterestComponent from '../AdditionalInsuredInterest/AdditionalInsuredInterestComponent';
 import WaterCraftComponent from '../WaterCraft/WaterCraftComponent';
import messages from './PackageInfoComponent.messages';
import styles from './PackageInfoComponent.module.scss';
import metadata from './PackageInfoComponent.metadata.json5';
import AddressComponent from "../../../nexus-capability-gateway-react/Components/Address/AddressComponent";


function PackageInfoComponent(props) {

    const {
        coverableVM,
        policyLocations,
        accountContacts,
        authHeader,
        jobID,
        updateAccountContacts,
        updateLocations,
        updatePackage,
        accountNumber,
        onValidate,
        id,
        packageIndex,
        isSubmission,
        additionalWizardData,
        updateAdditionalWizardData
    } = props;

    const {
        isComponentValid,
        registerComponentValidation,
    } = useValidation(id);

    const viewModelService = useContext(ViewModelServiceContext);
    const { EndorsementService } = useDependencies('EndorsementService');
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const localeService = ServiceManager.getService('locale-service');
    const translator = useContext(TranslatorContext);

    const [location, setLocation] = useState("")
    const [addLocation, setAddLocation] = useState(false);
    const [editLocation, setEditLocation] = useState(false);
    const [locationVM, setLocationVM] = useState({});
    const [showGeneralBuildingDetails, setShowGeneralBuildingDetails] = useState(false);
    const [showOtherBuildingDetails, setShowOtherBuildingDetails] = useState(false);
    const [isPageLoaded, setPageLoaded] = useState(false);
    const [constructionTypeCodeList, updateConstructionTypeCodeList ] = useState([]);
    const isCoverableValid = useCallback(() => {
        selectedCoverageForm();        
        if (
            !coverableVM.aspects.valid
            || (!coverableVM.aspects.subtreeValid)
        ) {
            return false;
        }
        return true;
    }, [coverableVM]);

    useEffect(() => {
        setShowGeneralBuildingDetails(true);
        setShowOtherBuildingDetails(true);    
           
    }, []);

    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid);
        }
    }, [id, isComponentValid, onValidate]);

    useEffect(() => {
        setLocation(_.get(coverableVM, 'location.publicID.value'));
        if(!isPageLoaded){
            //if (packageIndex === 0) {
            //    setLocation(_.get(coverableVM, 'location.publicID.value'));
            //}
            if(coverableVM.coverageForm.value.code === 'seatrailers_ey'){
                _.set(coverableVM, 'vacationTrailerDetails.isVacationValidationRequired', true);
                updatePackage(coverableVM.value);
            }
            if(coverableVM.coverageForm.value.code === 'marine_ey'){
                _.set(coverableVM, 'waterCraftDetails.isWaterValidationRequired', true);
                updatePackage(coverableVM.value);
            } 
            registerComponentValidation(isCoverableValid);
            setPageLoaded(true);
        }  
        const constructionCodes = coverableVM.omiaDetail.primaryConstructionType ? coverableVM.omiaDetail.primaryConstructionType.aspects.availableValues.map((constructionObj) => {
            if (constructionObj.code === 'log') {
                return {
                    code: constructionObj.code,
                    name: 'Log / Timberframe'
                };
            }else {
                return {
                    code: constructionObj.code,
                    name: translator({
                        id: constructionObj.name,
                        defaultMessage: constructionObj.name
                    })
                };
            }
        }) : [];
        updateConstructionTypeCodeList(constructionCodes);      
    }, [coverableVM, registerComponentValidation, isCoverableValid, isPageLoaded]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(coverableVM, path, value);
            updatePackage(coverableVM.value);
        },
        [coverableVM]
    );
    
    const isRentalOccupancyType = () => {
         //coverableVM.coverageForm.value.code === 'standard_ey' &&
         return coverableVM.coveragePart.value.code === 'rented_ey';
    }

    const isMobileOccupancy = () => {
        return coverableVM.coveragePart.value.code === 'nonpackage_ey' && coverableVM.coverageForm.value.code === 'mobilehome_ey';
    }

    const isSecondaryOccupancy = () => {
        return coverableVM.coveragePart.value.code === 'sechomeowners_ey';
    }

    const selectedCoverageForm = () => {
        var flag = false;
        if(coverableVM.coverageForm.value.code === 'miscitem_ey' || coverableVM.coverageForm.value.code === 'marine_ey' || coverableVM.coverageForm.value.code === 'seatrailers_ey'){
            coverableVM.omiaDetail.isValidationRequired.value=false;
            coverableVM.isHoValidationRequired.value=false; 
            coverableVM.waterCraftDetails.isWaterValidationRequired = false;
            if(coverableVM.coverageForm.value.code === 'marine_ey'){
                coverableVM.waterCraftDetails.isWaterValidationRequired = true;
            }          
            flag = true;
        }
        return flag
   }

    const createLocationVM = (model) => {
        const _locationVM = viewModelService.create(
            model,
            'pc',
            'edge.capabilities.policyjob.helper.PolicyLocationDTO'
        );
        return _locationVM
    };

    const handleAddNewLocation = () => {
        const model = { country: localeService.getDefaultCountryCode(), state: 'ON' };
        setLocationVM(createLocationVM(model));
        setAddLocation(true);
        setEditLocation(false);

    };

    const handleEditNewLocation = () => {
        const model = _.get(coverableVM, `location.value`);
        setLocationVM(createLocationVM(model));
        setAddLocation(false);
        setEditLocation(true);
    };

    const cancelPackageLocationUpdate = async () => {
        setAddLocation(false);
        setEditLocation(false);
    }

    const createUpdatePackageLocation = async () => {
        let updatedLocation = {}
        if(isSubmission === 'true') {
             updatedLocation = await LoadSaveService.createOrUpdatePolicyLocation([jobID, locationVM.value,null], authHeader);
        } else {
             updatedLocation = await EndorsementService.createOrUpdatePolicyLocation([jobID, locationVM.value], authHeader);
        }
        coverableVM.location.value = updatedLocation;
        setLocation(updatedLocation.publicID);
        let updatedLocations = {};
        if(isSubmission === 'true') {
             updatedLocations = await LoadSaveService.getPolicyLocations(jobID,false,  authHeader);
        }
        else {
             updatedLocations = await EndorsementService.getPolicyLocations([jobID], authHeader);
        }

        updateLocations(updatedLocations);
        coverableVM.omiaDetail.isNewLocation.value = true;
        setAddLocation(false);
        setEditLocation(false);
    };

    const OnAddressValueChange = (value, path) => {
        const newLocationVM = viewModelService.clone(locationVM);
        _.set(newLocationVM, path, value);
        setLocationVM(newLocationVM);
        writeValue(newLocationVM.value, 'location');
    }

    const onLocationChange = (value) => {
        const _location = value;
        
        if(additionalWizardData && additionalWizardData.packageInfoDetails){
            const _additionalWizardData = _.clone(additionalWizardData);
            _additionalWizardData.packageInfoDetails[coverableVM.publicID.value] = false;
            updateAdditionalWizardData(_additionalWizardData);
        }
        
        coverableVM.location.value = policyLocations.filter((loc) => { return loc.publicID == value })[0];
        setLocation(_location);
    };

    const toggleGeneralDetails = () => {
        setShowGeneralBuildingDetails(!showGeneralBuildingDetails);
    }

    const toggleOtherBuildingDetails = () => {
        setShowOtherBuildingDetails(!showOtherBuildingDetails);
    };

    const generateFieldsVisibilityOverride = () => {
        const fieldsList = [
            {
                fields: ['sumpPumpAmount', 'backupPower', 'drainType'],
                path: 'omiaDetail.isSumpPump.value',
                valueToMatch: true
            },
            {
                fields: ['plumbingUpdateType', 'plumbingUpdateYear'],
                path: 'omiaDetail.hasPlumbingUpdated.value',
                valueToMatch: true
            },
            {
                fields: ['addPlumbingType'],
                path: 'omiaDetail.hasAddPlumbSupply.value',
                valueToMatch: true
            },
            {
                fields: ['otherWiringType'],
                path: 'omiaDetail.hasOtherWiring.value',
                valueToMatch: true
            },
            {
                fields: ['elecUpdateType', 'elecUpdateYear'],
                path: 'omiaDetail.hasElecUpdated.value',
                valueToMatch: true
            },
            {
                fields: ['roofUpdateType', 'roofUpdateYear'],
                path: 'omiaDetail.hasRoofUpdated.value',
                valueToMatch: true
            },
            {
                fields: ['heatingUpdateType', 'heatingUpdateYear'],
                path: 'omiaDetail.hasheatingUpdated.value',
                valueToMatch: true
            },
            // {
            //     fields: ['basementFinishedPercent'],
            //     path: 'omiaDetail.isBasementFinished.value',
            //     valueToMatch: true
            // },
            {
                fields: ['isPoolCompliant'],
                path: 'omiaDetail.hasPool.value',
                valueToMatch: true
            },
            {
                fields: ['isHottubComplaint'],
                path: 'omiaDetail.hasHotTub.value',
                valueToMatch: true
            },
            {
                fields: ['numberOfPond'],
                path: 'omiaDetail.isAnyPond.value',
                valueToMatch: true
            },
            {
                fields: ['isTied','isSkirted'],
                conditional:[
                    [{
                        path:'omiaDetail.coveragePart.value.code',                        
                        valueToMatch:['nonpackage_ey','vacantunoccupied_ey']
                    }],
                    [{
                        path:'omiaDetail.coverageForm.value.code',
                        valueToMatch:['mobilehome_ey']
                    }]
                ]
            },
            {
                fields: ['typeOfBusinss'],
                path: 'omiaDetail.anytypeOfHomeBusiness.value',
                valueToMatch: true
            },
            {
                fields: ['noOilTanksInDwelling', 'isInspectionRptRecieved', 'oilTankYear', 'tankLocation', 'oilFilterLocation', 'oilTankOutletLocation', 'tankType', 'tankGauge', 'billReceived'],
                path: 'omiaDetail.primaryFuel.value.code',
                valueToMatch: ['O', 'X', 'recycledOil', 'electricoil']
            },
            {
                fields: ['fullTimeFireDepartment'],
                path: 'fireProtectionGrade.value.code',
                valueToMatch: ['1']
            },
            {
                fields: ['superiorShuttle'],
                path: 'fireProtectionGrade.value.code',
                valueToMatch: ['1','2']
            },
            {
                fields: ['distanceToFirehall_EY'],
                path: 'superiorShuttle.value',
                valueToMatch: true
            },
            {
                fields: ['noWoodstovesInOutbuilding'],
                path: 'omiaDetail.hasWoodstovesinOutbuilding.value',
                valueToMatch:true
            },
            {
                fields: ['noWoodstovesInDwelling'],
                path: 'omiaDetail.hasWoodstovesinDwelling.value',
                valueToMatch:true
            },
            {
                fields: ['noWoodstovesInOutbuildingSec'],
                path: 'omiaDetail.hasWoodstovesinOutbuildingSec.value',
                valueToMatch:true
            },
            {
                fields: ['noWoodstovesInDwellingSec'],
                path: 'omiaDetail.hasWoodstovesinDwellingSec.value',
                valueToMatch:true
            },
            {
                fields: ['noOilTanksInDwellingSec', 'isInspectionRptRecievedSec', 'oilTankYearSec', 'tankLocationSec', 'oilFilterLocationSec', 'oilTankOutletLocationSec', 'tankTypeSec', 'tankGaugeSec', 'secondaryFuelBillReceived'],
                path: 'omiaDetail.secondaryFuel.value.code',
                valueToMatch: ['O', 'X', 'recycledOil', 'electricoil']
            },
            {
                fields: ['isCSAULCApproved', 'isProInstalled', 'isProCleaned', 'hasWoodstovesinDwelling', 'hasWoodstovesinOutbuilding', 'moreDetails'],
                path: 'omiaDetail.primaryFuel.value.code',
                valueToMatch: ['Y', 'X', 'F', 'W', 'woodgas', 'wood', 'pellet', 'grain', 'solidfuel_EY', 'woodgas_ey', 'othersolid']
            },
            {
                fields: ['isCSAULCApprovedSec', 'isProInstalledSec', 'isProCleanedSec', 'hasWoodstovesinDwellingSec', 'hasWoodstovesinOutbuildingSec', 'moreDetailsSec'],
                path: 'omiaDetail.secondaryFuel.value.code',
                valueToMatch: ['Y', 'X', 'F', 'W', 'woodgas', 'wood', 'pellet', 'grain', 'solidfuel_EY', 'woodgas_ey', 'othersolid']
            },
            {
                fields: ['isComapliantInsFormRec'],
                conditional:[
                    [{
                        path:'omiaDetail.primaryFuel.value.code',
                        //valueToMatch: 'woodgas_ey'
                        valueToMatch:['Y', 'X', 'woodgas_ey', 'wood', 'pellet', 'grain', 'solidfuel_EY']
                    }],
                    [{
                        path:'omiaDetail.secondaryFuel.value.code',                        
                        //valueToMatch: 'woodgas_ey'
                        valueToMatch:['Y', 'X', 'woodgas_ey', 'wood', 'pellet', 'grain', 'solidfuel_EY']
                    }]
                ]
            },
            
            {
                fields: ['wettNum'],
                path: 'omiaDetail.isComapliantInsFormRec.value',
                valueToMatch: true
            },
            /*{
                fields: ['isCSAULCApproved', 'isProInstalled', 'isProCleaned', 'hasWoodstovesinDwelling', 'hasWoodstovesinOutbuilding', 'moreDetails'],
                path: 'omiaDetail.primaryHeating.value.code',
                valueToMatch: ['solidfuel'],
                conditional:[
                    [{
                        path:'omiaDetail.primaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.primaryFuel.value.code',
                        valueToMatch:'wood'
                    }],
                    [{
                        path:'omiaDetail.primaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.primaryFuel.value.code',
                        valueToMatch:'pellet'
                    }],
                    [{
                        path:'omiaDetail.primaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.primaryFuel.value.code',
                        valueToMatch:'othersolid'
                    }]
                ]
            },
            {
                fields: ['isCSAULCApprovedSec', 'isProInstalledSec', 'isProCleanedSec', 'hasWoodstovesinDwellingSec', 'hasWoodstovesinOutbuildingSec', 'moreDetailsSec'],
                path: 'omiaDetail.secondaryHeating.value.code',
                valueToMatch: ['solidfuel'],
                conditional:[
                    [{
                        path:'omiaDetail.secondaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.secondaryFuel.value.code',
                        valueToMatch:'wood'
                    }],
                    [{
                        path:'omiaDetail.secondaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.secondaryFuel.value.code',
                        valueToMatch:'pellet'
                    }],
                    [{
                        path:'omiaDetail.secondaryHeating.value.code',
                        valueToMatch:'fireplaceinsert'
                    },
                    {
                        path:'omiaDetail.secondaryFuel.value.code',
                        valueToMatch:'othersolid'
                    }]
                ]
            },*/
            {
                fields: ['hasBuildingElec_EY', 'hasBuildingHeated_EY', 'hasBuildingPlumb_EY'],
                path: 'coverageForm.value.code',
                valueToMatch: ['outbuilding_ey', 'detachedprivstru_ey']
            }
        ]

        const overrides = fieldsList.map((fs) => {
            const ovrRides = fs.fields.map((field) => {
                let isVisible = false;
                if(Array.isArray(fs.valueToMatch)){
                    _.each(fs.valueToMatch, (valueToMatch) => {
                        if(!isVisible){
                            isVisible = _.get(coverableVM, `${fs.path}`) == valueToMatch;
                        }                        
                    });
                }
                else if(fs.path) {
                    isVisible = _.get(coverableVM, `${fs.path}`) == fs.valueToMatch;                    
                }
                if(!isVisible && fs.conditional){
                    let isOneConditionPassed = false
                    _.each(fs.conditional, (condition) => {
                        let isAllInternalConditionPassed = true;
                        _.each(condition, (c) => {
                            if(Array.isArray(c.valueToMatch)){
                                var value =  _.get(coverableVM, `${c.path}`);
                                if(c.valueToMatch.indexOf(value) == -1){
                                    isAllInternalConditionPassed = false
                                }
                            }
                            else if(_.get(coverableVM, c.path) != c.valueToMatch){
                                    isAllInternalConditionPassed = false
                                }                            
                        });
                            if(!isOneConditionPassed){
                                isOneConditionPassed = isAllInternalConditionPassed;
                            }                        
                    })
                    isVisible = isOneConditionPassed
                }
                if (!isVisible && field !== 'hasBuildingHeated_EY' && field !== 'hasBuildingElec_EY' && field !== 'hasBuildingPlumb_EY') _.set(coverableVM, `omiaDetail.${field}`, undefined);
                return {
                    [`${field}`]: {
                        visible: isVisible
                    }
                }
            });
            return Object.assign({}, ...ovrRides);
        })
        return Object.assign({}, ...overrides);
    };


    const generateOverrides = () => {
        return {
            packageLocation: {
                availableValues: policyLocations,
                onValueChange: onLocationChange,
                value: location
            },
            editNewLocationButton: {
                onClick: handleEditNewLocation,
                disabled: addLocation || editLocation
            },
            addNewLocationButton: {
                onClick: handleAddNewLocation,
                disabled: addLocation || editLocation
            },
            addressLookupComponent: {
                visible: addLocation || editLocation,
                model: locationVM,
                hideFields: ['addressType'],
                readOnlyFields: ['country'],
                onValueChange: OnAddressValueChange,
                showCounty: true
            },
            addressLookupButtonContainer: {
                visible: addLocation || editLocation,
            },
            addAddressButton: {
                onClick: createUpdatePackageLocation,
                visible: addLocation
            },
            saveAddressButton: {
                onClick: createUpdatePackageLocation,
                visible: editLocation
            },
            cancelAddressButton: {
                onClick: cancelPackageLocationUpdate
            },
            toggleGeneralDetailsContainer: {
                onClick: toggleGeneralDetails,
                content: showGeneralBuildingDetails ? "Hide" : "Show"
            },
            GeneralDetailsContainer: {
                visible: showGeneralBuildingDetails
            },
            toggleOtherBuildingDetailsContainer: {
                onClick: toggleOtherBuildingDetails,
                content: showOtherBuildingDetails ? "Hide" : "Show"
            },
            OtherBuildingDetailsContainer: {
                visible: showOtherBuildingDetails
            },
            additionalInsured: {
                coverableVM: coverableVM,
                accountContacts: accountContacts,
                accountNumber: accountNumber,
                type: 'additionalInsuredDetail',
                updatePackage: updatePackage,
                authHeader: authHeader,
                onValueChange: writeValue,
                jobID:jobID,
                updateAccountContacts:updateAccountContacts,
                isSubmission : isSubmission === 'true'
            },
            additionalInterest: {
                coverableVM: coverableVM,
                accountContacts: accountContacts,
                accountNumber: accountNumber,
                updatePackage: updatePackage,
                authHeader: authHeader,
                type: 'additionalInterest',
                onValueChange: writeValue,
                updateAccountContacts:updateAccountContacts,
                jobID:jobID,
                isSubmission : isSubmission === 'true'
            },
            personalOccupancy : {
                visible : !isRentalOccupancyType() && !isMobileOccupancy() && !isSecondaryOccupancy()
            },
            rentalOccupancy : {
                visible : isRentalOccupancyType()
            },
            mobileHomeOccupancy:{
                visible : isMobileOccupancy()
            },
            secondaryHomeOccupancy:{
                visible : isSecondaryOccupancy()
            },
            packageDetailsContainer:{
                visible : !(coverableVM.coverageForm.value.code === 'miscitem_ey' || coverableVM.coverageForm.value.code === 'marine_ey' || coverableVM.coverageForm.value.code === 'seatrailers_ey')
            },
            boatDetailsContainer:{
                visible : (coverableVM.coverageForm.value.code === 'marine_ey')
            },
            boatDetailsDiv:{
                visible : (coverableVM.coverageForm.value.code === 'marine_ey' && !coverableVM.waterCraftDetails.isNoHull.value)
            },
            trailerContainer:{
                visible : (coverableVM.coverageForm.value.code === 'seatrailers_ey')
            },
            merchantile:{
                visible : (coverableVM.coveragePart.value.code === 'renters_ey')
            },
            waterCraftComponent:{
                coverableVM: coverableVM,
                type: 'waterCraftDetails',
                updatePackage: updatePackage,
                authHeader: authHeader,
                onValueChange: writeValue,
                packageIndex: packageIndex
            },
            plumbingContainer:{
                visible : coverableVM.omiaDetail && coverableVM.omiaDetail.hasBuildingPlumb_EY && coverableVM.omiaDetail.hasBuildingPlumb_EY.value === true
            },
            electricityContainer:{
                visible : coverableVM.omiaDetail && coverableVM.omiaDetail.hasBuildingElec_EY && coverableVM.omiaDetail.hasBuildingElec_EY.value === true
            },
            heatingContainer:{
                visible : coverableVM.omiaDetail && coverableVM.omiaDetail.hasBuildingHeated_EY && coverableVM.omiaDetail.hasBuildingHeated_EY.value === true
            },
            isTied : {
                visible : !isRentalOccupancyType()|| isMobileOccupancy() && isMobileOccupancy()
            },
            isSkirted : {
                visible : !isRentalOccupancyType() && !isMobileOccupancy() && !isSecondaryOccupancy()
            },
            primaryConstructionType: {
                availableValues: constructionTypeCodeList,
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            secondaryConstructionType: {
                availableValues: constructionTypeCodeList,
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            numFamilies: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            buildingArea: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            numStories: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            basementFinishedPercent: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            structureType: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            foundationType: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            numKitchens: {
                showRequired: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value),
                required: isSubmission === 'true' && coverableVM.coveragePart.value.code !== 'nonpackage_ey' && (!!coverableVM.omiaDetail.isARFCoverableEffectiveJuly2024.value)
            },
            ...generateFieldsVisibilityOverride()
        };
    }

    const overrideProps = {
        '@field': {
            labelPosition: 'left',
            onValueChange: writeValue,
            showRequired: true
        },
        ...generateOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {

        },
        resolveComponentMap: {
            addressComponent: AddressComponent,
            additionalInsuredInterestComponent: AdditionalInsuredInterestComponent,
            waterCraftComponent: WaterCraftComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={coverableVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={styles}
        />
    );
}

PackageInfoComponent.propTypes = {
    isValidate: PropTypes.func
}
export default PackageInfoComponent;
